export const headerTabs = [
  { title: "Home", key: "home" },
  { title: "Checklist Summary", key: "checklistSummary", roles: ['ins'] },
  { title: "Performance Report", key: 'owner',roles:['owner','cityops','centralmanager','centralteam','centraldashboard','superadmin'] },
  { title: "Patient Management", key: 'checklistSummary/hospitalView',roles:["Receptionist","Billing Professional","OT Staff","Nursing Staff","Floor Staff","RMO/CMO/Duty Doctor","RMO/CMO","Lab Staff","Dietitian","Insurance Hospital","Hospital Doctor","Duty Doctor","Admin","Anaesthetist"] }
]
// roles:['Ins']